<template>
    <div class="app-container">
      <a-card class="container">
        <div class="header">
          <img src="../../public/tudou.jpg" alt="达利担保" />
          <h1>{{ pageTitle }}</h1>
        </div>
        
        <div class="content">
            <h2>退押/下发 申请流程</h2>
          <p> 感谢您使用达利担保服务！</p>

          <p> 在提交 退押/下发 申请前，请联系群内交易员报备，确认所有 退押/下发 信息无误后再填写此表单。</p>
        
          
          <a-form
           style="display:grid"
            :model="formState"
            name="withdrawal-form"
           
          >
            <a-form-item
            style="margin-top: 8px;"
              label="TG联系方式"
              name="contact"
              :rules="[{ required: true, message: '请输入您的 TG 联系方式' }]"
            > 
            <label style="    display: block;
    font-size: 16px;
    margin-bottom: 8px;
    color: #333;">TG联系方式</label>
              <a-input style="    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;" v-model:value="formState.contact" placeholder="请输入您的 TG 联系方式" />
            </a-form-item>
            


            <a-form-item
             style="margin-top: 8px;"
              label="退押 / 下发 地址"
              name="withdrawalAddress"
              :rules="[{ required: true, message: '请输入您的 退押/下发 地址' }]"
            >
            <label  style="    display: block;
    font-size: 16px;
    margin-bottom: 8px;
    color: #333;">退押 / 下发 地址</label>
              <a-input style="    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;" v-model:value="formState.withdrawalAddress" placeholder="请输入您的 退押/下发 地址" />
            </a-form-item>
            
           
            <a-form-item
             style="margin-top: 8px;"
              label="纠纷描述（请简单概述主要的交易内容以及纠纷点）"
              name="remarks"
            >
            <label  style="    display: block;
    font-size: 16px;
    margin-bottom: 8px;
    color: #333;"> 纠纷描述（请简单概述主要的交易内容以及纠纷点）：</label>

              <a-textarea
                v-model:value="formState.remarks"
                placeholder="请输入其他需要说明的信息"
                :rows="4"
              />
            </a-form-item>
            
            
            <h2>提交申请后, 请用地址支付 0.8 USDT 进行地址核对验证。</h2>
           
            <p>
              核对后，我们的客服团队会尽快处理您的申请。
            </p>
            
            <a-form-item >
              <a-button
               style="    display: block;
    width: 100%;
    height: 55px;
    padding: 15px;
    font-size: 18px;
    color: #fff;
    background: #007bff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;"
                type="primary"
                @click="onFinish()"
                block
                :loading="loading"
              >
                提交申请
              </a-button>
            </a-form-item>
          </a-form>
        </div>
      </a-card>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import { addOrder } from '../util/api';
  import { message } from 'ant-design-vue';
  import { useRouter, useRoute } from 'vue-router';
  import { loadSpecialProduct, resolveLinkKey } from '../util/specialProduct';
  
  export default {
    setup() {
      const formState = ref({
        contact: '',
        withdrawalAddress: '',
        remarks: ''
      });
      const router = useRouter();
      const route = useRoute();
      const referral_code = ref('');
      const loading = ref(false);
      const pageTitle = ref('达利 退押/下发申请');
      
      const onFinish = async () => {
        loading.value = true;
        
        let title = "退押金到"+formState.value.withdrawalAddress
             
        let str = getCurrentDateTime() + Math.floor(Math.random() * 100000).toString().padStart(6, '0');
        let data = {
            price:0.8,
            inputNumber:1,
            inputGT:formState.value.contact,
            orderNo: str,
            title:title,
            referral_code:referral_code.value
        }
          
        try {
          
          await addOrder(data)

          router.push({ name: 'Payment', params: { data: JSON.stringify(data) } });
        } catch (error) {
          console.error('退押金失败:', error);
          message.error('退押金失败，请稍后重试');
        }
        
      };

       onMounted(async () => {
        const params = new URLSearchParams(window.location.search);
        referral_code.value = params.get("code");
        const key = resolveLinkKey(route) || 'tudou_db';
        const product = await loadSpecialProduct(key, { title: '达利 退押/下发申请' });
        pageTitle.value = product.title || pageTitle.value;
      });
      
      const onFinishFailed = (errorInfo) => {
        console.log('提交失败:', errorInfo);
      };

      const getCurrentDateTime =() =>  {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
        }
      
      return {
        formState,
        loading,
        pageTitle,
        onFinish,
        onFinishFailed
      };
    }
  };
  </script>
  
  <style scoped>
  .app-container {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
  }
  
  .container {
    width: 90%;
    max-width: 800px;
    border-radius: 10px;
    overflow: hidden;
    background:#FFF
  }
  
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    background: #007bff;
    color: #fff;
  }
  
  .header img {
    height: 50px;
  }
  
  .header h1 {
    font-size: 24px;
    margin: 0;
    color: #fff;
  }
  
  .content {
    padding: 30px;
  }
  
  .content h2 {
    font-size: 22px;
    margin-bottom: 10px;
    color: #333;
  }
  
  .content p {
    margin-bottom: 20px;
    line-height: 1.6;
    color: #555;
  }
  </style>